import axios from '@/axios'

const account = {
  //获取腾讯APPID  /validateAppId
  async getAppId(params = '') {
    return await axios.post('/validateAppId', params)
  },
  //发送验证码接口
  async sendPhoneCode(params, option) {
    return await axios.post('/validateSendcode', params, option)
  },
  //找回密码发送验证码  发送类型（1：手机 2：邮箱）
  async pwdCode(params) {
    return await axios.post('/queryPasswordCode', params, {
      des: '直客pc回密码发送验证码',
      sTime: new Date().getTime(),
    })
  },
  //真实账户注册接口
  async realRegister(params, option) {
    return await axios.post('/web/realaccount/register', params, option)
  },
  //模拟账户注册
  async demoRegister(params, option) {
    return await axios.post('/web/simulatoraccount/register', params, option)
  },
  //真实账户验证数据是否重复
  realUserData(params, option) {
    return axios.post('/web/realaccount/validate', params, option)
  },
  //模拟账户验证数据是否重复
  demoUserData(params, option) {
    return axios.post('/web/simulatoraccount/validate', params, option)
  },
  //接口开关
  getHkSwitch(params, option) {
    return axios.get('/common/bhswitch', params, option)
  },
  //国家地区
  getCountry(params, option) {
    return axios.post('/common/getCountry', params, option)
  },
  //banner
  getBanner(params, option) {
    return axios.post('/common/appPopupList', params, option)
  },
  // 获取用户ip归属地
  getIpAddress(params) {
    return axios.post('/common/getIpAddress', params)
  },
}

export default account



// WEBPACK FOOTER //
// ./src/api/account.js